module.exports = __webpack_public_path__ + "static/img/kimi.4bffebbd.svg";